import { JSX, useMemo } from "react";
import { useParams } from "react-router-dom";

import DashboardBlueprintView from "./DashboardBlueprintView";

export default function DashboardBlueprintPage(): JSX.Element {
	const { id } = useParams<{ id: string }>();

	const bpId = useMemo(() => (id ? parseInt(id, 10) : undefined), [id]);

	if (bpId === undefined) {
		return <></>;
	}

	return <DashboardBlueprintView id={bpId} />;
}
